import { render, staticRenderFns } from "./IOMonitor.vue?vue&type=template&id=b06143b0&scoped=true&"
import script from "./IOMonitor.vue?vue&type=script&lang=js&"
export * from "./IOMonitor.vue?vue&type=script&lang=js&"
import style0 from "./IOMonitor.vue?vue&type=style&index=0&id=b06143b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06143b0",
  null
  
)

export default component.exports